import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c12329be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex mb_10",
  style: {"color":"var(--el-text-color-regular)"}
}
const _hoisted_2 = {
  class: "mr_10",
  style: {"font-size":"12px"}
}
const _hoisted_3 = ["onClick", "onMousemove"]
const _hoisted_4 = { class: "code" }
const _hoisted_5 = { style: {"width":"100%"} }
const _hoisted_6 = { class: "picked" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"flex":"1"} }

import { computed, ref } from 'vue'
import { t } from '@/plugins/i18n'
import pantone from '@/apis/pantone'

export default /*#__PURE__*/_defineComponent({
  props: ['colors'],
  emits: ['update:colors'],
  setup(__props, { emit }) {

const props = __props


const list = pantone.data.getBook.colors.map((v) => {
  v.code = v.code.toUpperCase()
  return v
})
const filterList = computed(() =>
  keywd.value
    ? list.filter(
      (v) => v.hex.includes(keywd.value) || v.code.includes(keywd.value)
    )
    : list
)

const model = computed({
  get: () => props.colors ?? [],
  set: (val) => emit('update:colors', val)
})
const add = (v: any) => {
  if (model.value.length < 10) {
    model.value.includes(v) || model.value.push(v)
  }
}

const keywd = ref('')
const visible = ref(false)
const the: any = ref({})
const mousemove = (v, e) => {
  the.value = { ...v, top: e.y + 10 + 'px', left: e.x + 10 + 'px' }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('搜索色号')), 1),
      _createVNode(_component_el_input, {
        style: {"width":"200px"},
        modelValue: keywd.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywd).value = $event)),
        modelModifiers: { trim: true },
        placeholder: _unref(t)('色号或色卡名称')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createVNode(_component_el_scrollbar, {
      "max-height": "200px",
      always: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "box",
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (visible.value = true)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterList), (v) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "block",
              key: v.code,
              style: _normalizeStyle({ background: '#' + v.hex }),
              onClick: ($event: any) => (add(v)),
              onMousemove: ($event: any) => (mousemove(v, $event))
            }, null, 44, _hoisted_3))
          }), 128)),
          (visible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "float",
                style: _normalizeStyle({ top: the.value.top, left: the.value.left })
              }, [
                _createElementVNode("div", {
                  class: "cell",
                  style: _normalizeStyle({ background: '#' + the.value.hex })
                }, null, 4),
                _createElementVNode("div", _hoisted_4, _toDisplayString(the.value.code), 1)
              ], 4))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createTextVNode(_toDisplayString(_unref(t)('已选色卡')) + " ", 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model), (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.code
          }, [
            _createElementVNode("i", {
              class: "del fa fa-close",
              onClick: ($event: any) => (_unref(model).splice(i, 1))
            }, null, 8, _hoisted_7),
            _createElementVNode("div", {
              class: "tag",
              style: _normalizeStyle({ background: '#' + v.hex })
            }, null, 4),
            _createElementVNode("div", _hoisted_8, _toDisplayString(v.code), 1)
          ]))
        }), 128))
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})